import { useState } from "react";
import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import DirectUseSoldTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import "./index.css";
import directIcon from "../../../../../assets/design-revamp-company/category-icons/direct-use-icon.svg";
const CompDirectUseSoldContent = ({ businessId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState(false);
  return (
    <div className="use-sold-contents">
      <div style={{ display: "flex", alignItems: "center" }}>
        <SubHeaderBox
          subTitle={t("COMP_DIRECT_TITLE")}
          isNormal={true}
          number={"17.1.1"}
          icon={directIcon}
        />
      </div>
      {showTable && <DirectUseSoldTable businessId={businessId} />}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default CompDirectUseSoldContent;
